export enum MO {
    TIER_IPGROUP = 645,
    GUARANTEED_CAPACITY_INFO = 61,
    STORAGE_POOL = 216,
    HOST_TYPE = 21,
    FC_PORT_TYPE = 212,
    ETH_PORT_TYPE = 213,
    BOND_PORT = 235,
    LIF_PORT_TYPE = 279,
    VLAN = 280,
    ISCSI_TARGET = 249,
    FCOE_PORT_TYPE = 252,
    IB_PORT_TYPE = 16500,
    HOST_GROUP_TYPE = 14,
    PORT_GROUP_TYPE = 257,
    NET_SPACE = 826,
    FC_TYPE = 223,
    ISCSI_TYPE = 222,
    NVMeoF_RoCE_TYPE = 57870,
    FC_LINK = 225,
    ISCSI_LINK = 243,
    LUN = 11,
    LUN_GROUP = 256,
    PROTECT_GROUP = 57846,
    HYPER_METRO_CG = 15364,
    HYPER_METRO_PAIR = 15361,
    REPLICATION_CG = 221,
    SNAPSHOT_CG = 57646,
    SNAPSHOT = 27,
    LUN_PATH = 277,
    REMOTE_LUN = 250,
    SERIAL_PORT = 215,
    SAS_PORT = 214,
    FAN = 211,
    FAN_CTRL = 306,
    EXP_BOARD = 208,
    BBU = 210,
    POWER = 23,
    INTF_MODULE = 209,
    CONTROLLER = 207,
    ENCLOSURE = 206,
    BAY = 205,
    DISK = 10,
    REP_PORT_GROUP = 20485,
    REMOTE_DEVICE = 224,
    SYSTEM = 201,
    HYPER_METRO_DOMAIN = 15362,
    QUORUM_SERVER = 15363,
    CLONE_PAIR = 57702,
    CLONE_CG = 57703,
    SNAPSHOT_SCHEDULE = 57527,
    LUN_CDP = 57671,
    FILE_CDP = 12580,
    DRSTAR_MEMBER = 57508,
    FILE_SYSTEM = 40,
    DTREE = 16445,
    FAILOVER_GROUP_TYPE = 289,
    FILE_SYSTEM_FOR_REPLICA = 114,
    AD_CONFIG = 16414,
    SMARTCACHE_POOL = 218,
    SMARTCACHE_POOL_ENGINE = 266,
    SMARTCACHE_PARTITION = 273,
    MAPPING_VIEW = 245,
    NFSV41 = 57636,
    NFSV3 = 1000,
    NFS_SHARE = 16401,
    CIFS_SHARE = 16402,
    SMBV2 = 1003,
    VSTORES = 16442,
    NAMESPACE = 57356,
    NAMESPACE_GROUP = 60014,
    // 术语变更 riser-->carrier-->box
    CARRIER = 756,
    MANAGEMENT_BOARD = 766,
    COMPUTE_NODE = 764,
    PV = 755,
    POD = 57886,
    FRONT_PORT = 6,
    BACK_PORT = 7,
    SMART_MOVE = 1006,
    SMART_MOVE_FS_PAIR = 824,
    SWITCH_PORT = 984,
    SWITCH = 986,
}

export enum LOGICTYPE {
    /**
     * 级联框（硬盘框）
     */
    disk = '0',
    /**
     * 控制框
     */
    controller = '1',
    /**
     * 数据交换机
     */
    dataSwitch = '2',
    /**
     * 管理交换机
     */
    managementSwitch = '3',
    /**
     * 管理服务器
     */
    managementServer = '4'
}
